import { Container, Grid2, SxProps, Theme, Typography } from '@mui/material';
import TransText from 'next-translate/TransText';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import PlainLink from '../Links/PlainLink';
import Advantage, { AdvantageType } from '@components/Offer/Advantage';
import { CONTACT_EMAIL } from '@utils/consts/livv';

const containerSx: SxProps = {
    background: 'url("/assets/livv-bg.svg") top center no-repeat',
    backgroundSize: { md: 'contain', xs: '90%' },
    pt: { md: 0, xs: 3 },
};

const pricingSubtitleSx: SxProps<Theme> = {
    color: 'grey100',
    fontFamily: (theme: Theme) => theme.typography.h1.fontFamily,
    fontSize: 18,
    pb: 1.5,
    pt: 2,
};

const Offer: FC = () => {
    const { t } = useTranslation('offer');

    const CHECK_LIST_ITEM: AdvantageType[] = [
        {
            id: 'aiSearch',
            img: 'ai-search.svg',
        },
        {
            id: 'thematicPlan',
            img: 'jusdgment.svg',
        },
        {
            id: 'search',
            img: 'noQuery.svg',
        },
        {
            id: 'books',
            img: 'noResult.svg',
        },
        {
            id: 'site',
            img: 'error.svg',
        },
    ];

    return (
        <Container data-test-id="offer" sx={containerSx}>
            <Grid2 alignItems="center" mt={0} spacing={2} container>
                <Grid2 size={{ md: 6 }}>
                    <Typography sx={pricingSubtitleSx}>
                        <TransText
                            components={{
                                ContactLink: (
                                    <PlainLink
                                        key="contact"
                                        href={`mailto:${CONTACT_EMAIL}`}
                                        underline="always"
                                    >
                                        {CONTACT_EMAIL}
                                    </PlainLink>
                                ),
                            }}
                            text={t('pricing.title')}
                        />
                    </Typography>
                    <Grid2 direction="column" rowGap={2} container>
                        {CHECK_LIST_ITEM.map((advantage) => (
                            <Advantage key={advantage.id} advantage={advantage} />
                        ))}
                    </Grid2>
                </Grid2>
                <Grid2 mb={6} size={{ md: 6 }}>
                    <img
                        alt=""
                        loading="lazy"
                        src="/assets/decision-livv.webp"
                        style={{ maxWidth: '100%' }}
                    />
                </Grid2>
            </Grid2>
        </Container>
    );
};

export default Offer;
